export default __webpack_public_path__ + "locales/ru/Settings.json?hash=8fe95e967cc92f7b4b815e16819a0050";